module.exports = __webpack_public_path__ + "img/kippe.974ccc52.svg";